export const revitHeroImage =
  "https://readdy.ai/api/search-image?query=Professional%203D%20BIM%20building%20model%20visualization%20showing%20detailed%20HVAC%20ductwork%20systems%2C%20air%20conditioning%20equipment%2C%20ventilation%20pipes%20and%20mechanical%20installations%20running%20through%20a%20modern%20building%20structure%2C%20teal%20and%20steel%20gray%20color%20palette%2C%20engineering%20technical%20render%2C%20clean%20detailed%20digital%20visualization%2C%20high%20quality%20architectural%20engineering%20presentation&width=1600&height=800&seq=revit-hero-1&orientation=landscape";

export const revitIntroImage =
  "https://readdy.ai/api/search-image?query=Detailed%20Revit%203D%20model%20of%20mechanical%20HVAC%20system%20with%20ducts%2C%20pipes%20and%20equipment%20for%20a%20building%2C%20teal%20highlighted%20systems%20on%20neutral%20gray%20background%2C%20engineering%20software%20interface%20render%2C%20technical%20precision%2C%20clean%20digital%20model%2C%20high%20detail%20visualization&width=900&height=600&seq=revit-intro-1&orientation=landscape";

export const revitBimImage =
  "https://readdy.ai/api/search-image?query=Exploded%203D%20BIM%20model%20of%20a%20modern%20multi-story%20building%20showing%20separated%20layers%20of%20architecture%2C%20structure%20and%20mechanical%20systems%2C%20teal%20and%20gray%20color%20coded%20layers%2C%20transparent%20building%20visualization%2C%20engineering%20technical%20render%2C%20clean%20minimal%20digital%20presentation&width=800&height=600&seq=revit-bim-1&orientation=landscape";

export const revitServices = [
  {
    title: "MODELADO BIM",
    description:
      "Representación tridimensional de sistemas y componentes de ingeniería.",
    icon: "ri-box-3-line",
  },
  {
    title: "MODELADO HVAC",
    description:
      "Diseño y modelado de sistemas de climatización, equipos y redes.",
    icon: "ri-temp-hot-line",
  },
  {
    title: "DISEÑO DE DUCTOS",
    description:
      "Desarrollo y distribución de redes de ductos para climatización y ventilación.",
    icon: "ri-node-tree",
  },
  {
    title: "MODELADO DE EQUIPOS",
    description:
      "Integración de equipos de aire acondicionado, ventilación y refrigeración dentro del modelo.",
    icon: "ri-cpu-line",
  },
  {
    title: "COORDINACIÓN BIM",
    description:
      "Coordinación de diferentes disciplinas para identificar interferencias antes de la construcción.",
    icon: "ri-git-merge-line",
  },
  {
    title: "DOCUMENTACIÓN TÉCNICA",
    description:
      "Generación de planos y documentación para facilitar la ejecución del proyecto.",
    icon: "ri-file-list-3-line",
  },
] as const;

export const revitBimLayers = [
  {
    title: "Arquitectura",
    description: "Representación digital del edificio y sus espacios.",
    icon: "ri-building-2-line",
  },
  {
    title: "Estructura",
    description: "Elementos estructurales integrados en el modelo.",
    icon: "ri-layout-grid-line",
  },
  {
    title: "Climatización",
    description: "Sistemas de climatización y aire acondicionado.",
    icon: "ri-temp-hot-line",
  },
  {
    title: "Ventilación",
    description: "Redes de ductos y sistemas de renovación de aire.",
    icon: "ri-windy-line",
  },
  {
    title: "Refrigeración",
    description: "Equipos y sistemas de refrigeración modelados.",
    icon: "ri-snowy-line",
  },
  {
    title: "Instalaciones",
    description: "Coordinación de instalaciones y redes técnicas.",
    icon: "ri-plug-line",
  },
] as const;

export const revitAdvantages = [
  {
    title: "VISUALIZACIÓN 3D",
    description: "Comprende el proyecto antes de iniciar la construcción.",
    icon: "ri-eye-line",
  },
  {
    title: "MAYOR PRECISIÓN",
    description: "Planifica recorridos, equipos y redes con mayor detalle.",
    icon: "ri-focus-3-line",
  },
  {
    title: "DETECCIÓN DE INTERFERENCIAS",
    description: "Identifica conflictos entre sistemas antes de llegar a obra.",
    icon: "ri-alert-line",
  },
  {
    title: "MEJOR COORDINACIÓN",
    description: "Facilita la comunicación entre las diferentes disciplinas del proyecto.",
    icon: "ri-team-line",
  },
] as const;

export const revitProcess = [
  {
    step: "01",
    title: "LEVANTAMIENTO DE INFORMACIÓN",
    description: "Recopilación de planos, dimensiones y requerimientos.",
  },
  {
    step: "02",
    title: "MODELADO",
    description: "Construcción del modelo digital del sistema.",
  },
  {
    step: "03",
    title: "DISEÑO",
    description: "Desarrollo de redes, equipos y componentes.",
  },
  {
    step: "04",
    title: "COORDINACIÓN",
    description: "Revisión de interferencias y compatibilidad.",
  },
  {
    step: "05",
    title: "DOCUMENTACIÓN",
    description: "Generación de planos y entregables técnicos.",
  },
] as const;

export const revitApplications = [
  {
    title: "Sistemas HVAC",
    icon: "ri-temp-hot-line",
  },
  {
    title: "Ventilación mecánica",
    icon: "ri-windy-line",
  },
  {
    title: "Aire acondicionado",
    icon: "ri-snowy-line",
  },
  {
    title: "Refrigeración",
    icon: "ri-fridge-line",
  },
  {
    title: "Proyectos comerciales",
    icon: "ri-store-2-line",
  },
  {
    title: "Proyectos industriales",
    icon: "ri-building-4-line",
  },
  {
    title: "Edificaciones",
    icon: "ri-building-2-line",
  },
  {
    title: "Remodelaciones",
    icon: "ri-hammer-line",
  },
] as const;